import React, { Component } from "react";
import classnames from "classnames";
import { Input, FormGroup, Label, Tooltip } from "reactstrap";
import API from "../../api/index";
import { NotificationManager } from "Components/ReactNotifications";
import { TooltipItem } from "Components/PopoverTooltip";

export const parentCustomerMobileObject = {
	mobile: "",
	isValid: false,
	isLead: false,
	isCustomer: false,
	customerObject: {},
};

class CustomerMobileLookup extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchCustomer: {
				Name: "",
				SurName: "",
				Gender: "",
				ID: "",
				LastAddress: "",
				LastAddressComplete: "",
				SuccessOrders: {
					Count: 0,
					Amount: 0,
					Unit: "",
					UnitFa: "",
				},
				isLead: false,
				LeadID: -1,
			},
			showAddressTooltip:false,
			customerMobile: "",
		};

		this.lookupCustomer = this.lookupCustomer.bind(this);
		this.validateMobile = this.validateMobile.bind(this);
		this.cleanCustomerMobile = this.cleanCustomerMobile.bind(this);
	}
	handleCopyToClipboard = (answer, id) => {
		navigator.clipboard.writeText(answer);
		// Set the background to gray for the specific card
		document.getElementById(id).style.opacity = "0.2";
		// Reset the background after 200 milliseconds (adjust timing as needed)
		setTimeout(() => {
			document.getElementById(id).style.opacity = "1";
		}, 200);
	};
	lookupCustomer(mobile) {
		if (this.validateMobile(mobile)) {
			API.order.new
				.lookupCustomer({ CustomerMobile: mobile })
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
					if (data.CUSTOMER !== undefined) {
						this.setState({ searchCustomer: data.CUSTOMER }, () => {
							this.props.onCustomerMobileChange({
								mobile: this.state.customerMobile,
								isValid: this.validateMobile(this.state.customerMobile),
								isCustomer: this.state.searchCustomer.ID !== "",
								isLead: this.state.searchCustomer.isLead === true,
								customerObject: this.state.searchCustomer,
							});
						});
					} else {
						this.setState(
							{
								searchCustomer: {
									Name: "",
									SurName: "",
									Gender: "",
									ID: "",
									isLead: false,
									LeadID: -1,
									LastAddress: "",
									LastAddressComplete:"",
									SuccessOrders: {
										Count: 0,
										Amount: 0,
										Unit: "",
										UnitFa: "",
									},
								},
							},
							() => {
								this.props.onCustomerMobileChange({
									mobile: this.state.customerMobile,
									isValid: this.validateMobile(this.state.customerMobile),
									isCustomer: this.state.searchCustomer.ID !== "",
									isLead: (this.state.searchCustomer.isLead === true) === true,
									customerObject: this.state.searchCustomer,
								});
							}
						);
					}

					if (data.ERRORS !== undefined) {
						for (var i = 0; i < data.ERRORS.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.success(err, "بررسی شماره مشتری", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.ERRORS[i]
							);
						}
					}
				})
				.catch((error) => {
					this.setState(
						{
							searchCustomer: {
								Name: "",
								SurName: "",
								Gender: "",
								ID: "",
								isLead: false,
								LeadID: -1,
								LastAddress: "",
								LastAddressComplete:"",
								SuccessOrders: {
									Count: 0,
									Amount: 0,
									Unit: "",
									UnitFa: "",
								},
							},
						},
						() => {
							this.props.onCustomerMobileChange({
								mobile: this.state.customerMobile,
								isValid: this.validateMobile(this.state.customerMobile),
								isCustomer: this.state.searchCustomer.ID !== "",
								isLead: this.state.searchCustomer.isLead === true,
								customerObject: this.state.searchCustomer,
							});
						}
					);
				});
		} else {
			this.setState(
				{
					searchCustomer: {
						Name: "",
						SurName: "",
						Gender: "",
						ID: "",
						isLead: false,
						LeadID: -1,
						LastAddress: "",
						LastAddressComplete:"",
						SuccessOrders: {
							Count: 0,
							Amount: 0,
							Unit: "",
							UnitFa: "",
						},
					},
				},
				() => {
					this.props.onCustomerMobileChange({
						mobile: this.state.customerMobile,
						isValid: this.validateMobile(this.state.customerMobile),
						isCustomer: this.state.searchCustomer.ID !== "",
						isLead: this.state.searchCustomer.isLead === true,
						customerObject: this.state.searchCustomer,
					});
				}
			);
		}
	}
	cleanCustomerMobile(mobile) {
		mobile = mobile.split(" ").join("");
		mobile = mobile.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d)).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

		// console.log(mobile,mobile.indexOf("0098"))
		if (mobile.indexOf("0098") === 0) {
			mobile = mobile.replace("0098", "0");
		}
		if (mobile.indexOf("098") === 0) {
			mobile = mobile.replace("098", "0");
		}
		if (mobile.indexOf("+98") === 0) {
			mobile = mobile.replace("+98", "0");
		}
		if (mobile.indexOf("98") === 0) {
			mobile = mobile.replace("98", "0");
		}
		if (mobile.indexOf("9") === 0 && mobile.length == 10) {
			mobile = "0" + mobile;
		}
		return mobile;
	}

	validateMobile(mobile) {
		if (mobile.trim() == "") {
			return false;
		}
		return mobile.match(/^(0)+(9|$)\d{9}$/g) != null;
	}
	reset() {
		this.setState({
			searchCustomer: {
				Name: "",
				SurName: "",
				Gender: "",
				ID: "",
				isLead: false,
				LeadID: -1,
			},
			customerMobile: "",
		});
	}
	render() {
		const { customerMobileObject } = this.props;
		const customerMobile = customerMobileObject.mobile;

		return (
			<FormGroup className={"component-customerMobile filter " + (this.props.isValid ? "filter-active" : "")} style={{ borderRightColor: !this.props.isValid ? "#fccdd2" : "#4fcdc4" }}>
				{this.state.searchCustomer.ID !== "" ? (
					<span>
						<a
							href={"/app/customers/view-customer/" + customerMobile}
							target="_blank"
							className={classnames({
								"iconsminds-business-man": this.state.searchCustomer.Gender === "MALE",
								"iconsminds-business-woman": this.state.searchCustomer.Gender === "FEMALE",
								headingicon: true,
							})}
						>
							{this.state.searchCustomer.Name} {this.state.searchCustomer.SurName}
							{/* #{this.state.searchCustomer.ID} */}
						</a>
						<span className="customer-quick-info">
							<span className="order-count">
								{this.state.searchCustomer.SuccessOrders.Count} <i>فاکتور</i>
							</span>
							<span className={"order-total " + this.state.searchCustomer.SuccessOrders.Unit}>
								{this.state.searchCustomer.SuccessOrders.Amount}
								<i>{this.state.searchCustomer.SuccessOrders.UnitFa}</i>
							</span>
						</span>
					</span>
				) : this.state.searchCustomer.isLead ? (
					<a href={"/app/crm/lead/view/" + customerMobile} target="_blank" className="iconsminds-pulse headingicon">
						سرنخ با{" "}
						<span className="pulsecount" style={{ fontWeight: "bold" }}>
							{this.state.searchCustomer.PulseCount}
						</span>{" "}
						پالس
					</a>
				) : (
					<Label for="customerMobile">{this.validateMobile(customerMobile) ? <span> مشتری جدید*</span> : <span> موبایل مشتری</span>}</Label>
				)}
				<Input
					autoComplete="off"
					type="text"
					name="customerMobile"
					id="customermobile"
					placeholder=""
					value={this.state.customerMobile}
					onChange={(e) => {
						var cleanValue = this.cleanCustomerMobile(e.target.value);
						this.setState({ customerMobile: cleanValue });
						this.lookupCustomer(cleanValue);
						this.props.onCustomerMobileChange({
							mobile: cleanValue,
							isValid: this.validateMobile(cleanValue),
							isCustomer: this.state.searchCustomer.ID !== "",
							isLead: this.state.searchCustomer.isLead === true,
							customerObject: this.state.searchCustomer,
						});
					}}
				/>

				{this.state.searchCustomer.ID !== "" ? (
					<span className="customer-quick-address" style={{cursor:"pointer"}}
					onClick={() => this.setState({ showAddressTooltip: !this.state.showAddressTooltip })}
			  >
						<i className="iconsminds-map-marker-2" />
						{this.state.searchCustomer.LastAddress}
					</span>
				) : (
					<span />
				)}
				<div id="Tooltipaddress" style={{marginTop:"15px"}}>
					{this.state.searchCustomer.ID !== "" ? (
						<Tooltip
						className={"address-tooltip"}
							placement={"bottom"}
							isOpen={this.state.showAddressTooltip}
							target={"Tooltipaddress"}
							//   toggle={this.toggle}
						>
							{this.state.searchCustomer.ID !== "" ? (this.state.searchCustomer.LastAddressComplete
						):("")}
						<i style={{cursor:"pointer"}} id={`copy-address-${this.state.searchCustomer.ID}`} className="iconsminds-files" onClick={()=>{this.handleCopyToClipboard(this.state.searchCustomer.LastAddress+" - "+this.state.searchCustomer.LastAddressComplete, `copy-address-${this.state.searchCustomer.ID}`)}} />
						</Tooltip>
					) : (
						<span />
					)}
				</div>
			</FormGroup>
		);
	}
}

export default CustomerMobileLookup;
